import React, { PureComponent } from 'react';
import fecha from 'fecha';
import ReviewModal from '../ReviewModal';
import { ReviewStars } from './ReviewStars';
import {
  ContentReviewArea,
  ContentReviewCustomerName,
  ContentReviewDate,
  ContentReviewBody,
  ContentReviewReadMoreButton,
  ContentReviewSectionSeparator,
  ContentReviewStars,
  ReviewStarsText,
  ContentReviewBodyEllipsis,
  ContentReviewCustomerVehicle,
  ContentReviewCustomerLocation,
  ContentReviewCustomerVehicleLocationWrapper
} from './styles';

interface ContentReviewProps {
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  item: any;
  order?: number;
  trackEvent?();
  useEllipsis: boolean;
  useFade: boolean;
  updateUrlSearchParams?();
  updateContentReviewsSelectedReview?();
}

interface ContentReviewState {
  isReviewModalOpen: boolean;
}

class ContentReview extends PureComponent<
  ContentReviewProps,
  ContentReviewState
> {
  static defaultProps = {
    useEllipsis: false,
    useFade: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    trackEvent: () => {}
  };

  state = {
    isReviewModalOpen: false
  };

  setIsReviewModal(show) {
    this.setState({ isReviewModalOpen: show });
  }

  readMoreClick = e => {
    e.preventDefault();
    e.stopPropagation();
    // const { item } = this.props;
    // const payload = { selectedReview: item };

    // this.showModal();
  };

  render() {
    const { item, order, useEllipsis, useFade } = this.props;
    const { isReviewModalOpen } = this.state;

    const {
      review_text: reviewText,
      review_score: reviewScore,
      review_date: reviewDate,
      vehicle: { year, make, model },
      customer: { name, location }
    } = item;

    const score = parseFloat(reviewScore);

    return (
      <ContentReviewArea
        order={order}
        key={`review_area_${name}`}
        // minWidth={392}
      >
        <ContentReviewCustomerName>{name}</ContentReviewCustomerName>
        <ContentReviewDate>
          {fecha.format(new Date(reviewDate), 'mediumDate').toUpperCase()}
        </ContentReviewDate>
        <ContentReviewCustomerVehicleLocationWrapper>
          <ContentReviewCustomerVehicle>{`${year} ${make} ${model}`}</ContentReviewCustomerVehicle>
          <ContentReviewCustomerLocation>
            {location}
          </ContentReviewCustomerLocation>
        </ContentReviewCustomerVehicleLocationWrapper>

        <ContentReviewBody
          restrictHeight
          useFade
        >{`${reviewText}`}</ContentReviewBody>
        {useEllipsis && !useFade ? (
          <ContentReviewBodyEllipsis>...</ContentReviewBodyEllipsis>
        ) : null}
        <ContentReviewReadMoreButton
          data-cv-test={`Cv.Search.ContentReviews.Reviews.${order}.ReadMoreButton`}
          useFade
          onClick={() => this.setIsReviewModal(true)}
        >
          Read More
        </ContentReviewReadMoreButton>
        <ContentReviewSectionSeparator />
        <ContentReviewStars>
          {
            <>
              <ReviewStarsText>
                {`${score.toFixed(1)} OUT OF 5`}
              </ReviewStarsText>
              <ReviewStars score={score} />
            </>
          }
        </ContentReviewStars>
        <ReviewModal
          isOpen={isReviewModalOpen}
          onClose={() => this.setIsReviewModal(false)}
          text={reviewText}
          name={name}
          location={location}
          score={reviewScore}
          date={fecha.format(new Date(reviewDate), 'mediumDate').toUpperCase()}
          year={year}
          make={make}
          model={model}
        />
      </ContentReviewArea>
    );
  }
}

export default ContentReview;
